var _path, _path2, _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.813,23.038H6.187c-1.396,0-2.527,1.131-2.527,2.527v9.568c0,1.396,1.131,2.527,2.527,2.527h29.626c1.396,0,2.527-1.131,2.527-2.527v-9.568c0-1.396-1.131-2.527-2.527-2.527Zm-26.102,7.311c-.993,0-1.799-.805-1.799-1.799s.805-1.799,1.799-1.799,1.799.805,1.799,1.799-.805,1.799-1.799,1.799Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m35.813,4.34H6.187c-1.396,0-2.527,1.131-2.527,2.527v9.568c0,1.396,1.131,2.527,2.527,2.527h29.626c1.396,0,2.527-1.131,2.527-2.527V6.867c0-1.396-1.131-2.527-2.527-2.527Zm-26.102,7.311c-.993,0-1.799-.805-1.799-1.799s.805-1.799,1.799-1.799,1.799.805,1.799,1.799-.805,1.799-1.799,1.799Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 33.831,
    y1: 14.18,
    x2: 27.301,
    y2: 14.18
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23.015,
    y1: 14.18,
    x2: 17.913,
    y2: 14.18
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 33.831,
    y1: 32.878,
    x2: 27.301,
    y2: 32.878
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 23.015,
    y1: 32.878,
    x2: 17.913,
    y2: 32.878
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorServer);
export default __webpack_public_path__ + "static/media/indoor-server.7daf27d2a34367e3054a808619261e00.svg";
export { ForwardRef as ReactComponent };